/* import __COLOCATED_TEMPLATE__ from './import-zendesk-history.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();